import React from 'react';
import Formsy from 'formsy-react';
import SellerStripeForm from '../../components/SellerSignup/SellerStripeForm';
import PaymentCard from '../../components/SellerSignup/PaymentCard';
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import arrow from '../../assets/images/newui/back-arrow.svg'
import ErrorBox from '../../components/SellerSignup/ErrorBox';
import essentialImg from '../../assets/images/newui/sellersignup/essential.svg'
import premiumImg from '../../assets/images/newui/sellersignup/premium.svg'
import ultimateImg from '../../assets/images/newui/sellersignup/ultimate.svg'
import { Checkbox, Modal } from 'semantic-ui-react';
import exCards from '../../assets/images/newui/existing-card-black.svg'
import DisclaimerSection from 'components/DisclaimerSection/DisclaimerSection';
import './PaymentClearModal.less'

class PaymentClearModal extends React.Component {

    getImage = (type) => {
        switch (type) {
            case 'Essential':
                return essentialImg;
            case 'Premium':
                return premiumImg;
            case 'Ultimate':
                return ultimateImg;
            default:
                return premiumImg;
        }
    }


    render() {
        const { open, onClose, processFailedPayments, stripe, elements, onCardFormToggle, paymentMethods, setSelectedPaymentMethod, error, isCardFormVisible, selectedPaymentMethod, selectedSubscription, setCard, commissionPaymentsDetail } = this.props;
        return <Modal open={open} onClose={onClose} className='payment-clear-modal'>
            <Modal.Content>
                <Formsy onValidSubmit={processFailedPayments}>
                    <div className='payment-clear-modal-top'>
                        <div className='payment-clear-modal-close' onClick={onClose}><img src={arrow} /></div>
                        <div className='payment-clear-modal-heading'>Clear Failed Payments</div>

                        {selectedSubscription ? <div className='payment-clear-modal-plan-container'>
                            <div className='payment-clear-modal-plan-section'>
                                <img src={this.getImage(selectedSubscription.planName)} />
                                <div className='payment-clear-modal-plan-section-content'>
                                    <div className='payment-clear-modal-plan-header'>Plan</div>
                                    <div className='payment-clear-modal-plan-name'>{selectedSubscription.planName}</div>
                                </div>
                            </div>
                            <div className='payment-clear-modal-category-section'>
                                <img className='payment-clear-modal-category-img' src={selectedSubscription.detailImageNarrow ?
                                    selectedSubscription.detailImageNarrow.URL : ''} />
                                <div className='payment-clear-modal-category-section-content'>
                                    <div className='payment-clear-modal-category-header'>Category</div>
                                    <div className='payment-clear-modal-category-name'>{selectedSubscription.categoryName}</div>
                                </div>
                            </div>
                            <div className='payment-clear-modal-amount-section'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9.137" height="17.255" viewBox="0 0 9.137 17.255">
                                    <path id="Path_28815" data-name="Path 28815" d="M-5717.5,10588.752l9.137,8.627-9.137,8.628Z" transform="translate(5717.5 -10588.752)" fill="#7ac943" />
                                </svg>
                                <div className='payment-clear-modal-amount-header'>Total Amount</div>
                                <div className='payment-clear-modal-amount-text'><span>USD</span> ${Number(selectedSubscription.totalAmount ? selectedSubscription.totalAmount.toFixed(2) : 0)}</div>
                            </div>
                        </div> : ''}
                        {commissionPaymentsDetail ?
                            <div className='payment-clear-modal-plan-container'>
                                <div className='payment-clear-modal-commission-payment-count-section'>
                                    <div className='payment-clear-modal-amount-header'>No. of Payments</div>
                                    <div className='payment-clear-modal-amount-text'>{commissionPaymentsDetail.count}</div>
                                </div>
                                <div className='payment-clear-modal-commission-amount-section'>
                                    <div className='payment-clear-modal-amount-header'>Total Amount</div>
                                    <div className='payment-clear-modal-amount-text'><span>USD</span> ${Number(commissionPaymentsDetail.totalAmount ? commissionPaymentsDetail.totalAmount.toFixed(2) : 0)}</div>
                                </div>
                            </div> : ''}
                        {commissionPaymentsDetail ? <div className='payment-clear-modal-commission-disclaimer'>You will be charged individually for each payment.</div> : ''}
                    </div>
                    {isCardFormVisible ?
                        <div className='payment-clear-modal-card-form'>
                            <SellerStripeForm onExistingCardsClick={(e) => onCardFormToggle(e, false)} areCardsExists={paymentMethods.length} onChange={({ card }) => setCard(card)} stripe={stripe} elements={elements}  hideDisclaimer={!!commissionPaymentsDetail} />
                        </div>
                        : <div className='payment-clear-modal-existing-card-container'>
                            <div className='subscription-container-card-existing'>
                                <div className='subscription-container-card-existing-header'>
                                    Existing Cards
                                    <img src={exCards} className='payment-clear-modal-existing-card-img' />
                                    <div className='subscription-container-card-btn-container'>
                                        <button className='subscription-container-card-btn' onClick={(e) => onCardFormToggle(e, true)}><span>+</span> Add New Card <img src={next} /> </button>
                                    </div>
                                </div>
                                {paymentMethods.map(pm =>
                                    <div className='payment-clear-modal-existing-card' onClick={() => setSelectedPaymentMethod(pm)}><PaymentCard {...pm.card} isSelected={selectedPaymentMethod.id == pm.id} /></div>
                                )}
                            </div>
                            <DisclaimerSection buttonText='PAY NOW' />
                        </div>}
                    {this.props.setIsDefaultCard && <Checkbox className='payment-clear-modal-default-card' label='Use this card for all future payments' onChange={(e, data) => this.props.setIsDefaultCard(data.checked)} checked={this.props.isDefaultCard} />}
                    {error && <ErrorBox message={error} />}
                    <button className='payment-clear-modal-submit' type='submit'> PAY NOW <img src={next} /></button>
                </Formsy>
            </Modal.Content>
        </Modal>
    }
}
export default PaymentClearModal;